// extracted by mini-css-extract-plugin
export var linkText = "_ok-0";